import React from "react";
import { motion } from "framer-motion";
import "./Home.css";

const SVGMainBackground = () => {
  return (
    <motion.svg
      style={{ marginTop: "-9.5%" }}
      viewBox="0 0 1440 312"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Park" clipPath="url(#clip0_4_111)">
        <rect width="1440" height="312" fill="none" />
        <path
          id="Groungbg"
          d="M1429 311H-11C-11 311 281.37 261.443 711.996 262.005C714.412 262.005 716.829 262.012 719.246 262.019C727.836 262.041 736.476 262.083 745.165 262.143C751.968 262.195 758.799 262.258 765.657 262.333C768.619 262.363 771.582 262.399 774.561 262.436C775.753 262.45 776.928 262.465 778.103 262.479C780.834 262.516 783.582 262.552 786.346 262.596C791.527 262.669 796.724 262.757 801.938 262.844C806.506 262.925 811.096 263.012 815.709 263.107C817.463 263.136 819.251 263.173 821.022 263.217C829.381 263.385 837.772 263.579 846.197 263.801C848.15 263.852 850.103 263.903 852.073 263.954C854.771 264.02 857.485 264.1 860.183 264.173C863.759 264.276 867.334 264.38 870.909 264.487C875.56 264.626 880.194 264.772 884.846 264.925C894.578 265.239 904.366 265.585 914.208 265.962C921.524 266.232 928.857 266.532 936.222 266.839C939.35 266.97 942.49 267.106 945.64 267.247C950.456 267.452 955.284 267.669 960.123 267.897C963.201 268.043 966.297 268.189 969.375 268.335C973.099 268.511 976.807 268.693 980.531 268.883C984.239 269.073 987.979 269.263 991.703 269.46C995.444 269.657 999.185 269.857 1002.93 270.059C1006.68 270.263 1010.42 270.468 1014.18 270.687C1017.89 270.891 1021.6 271.11 1025.32 271.329C1041.18 272.256 1057.15 273.267 1073.24 274.359C1076.32 274.564 1079.43 274.776 1082.52 274.995C1085.72 275.214 1088.92 275.44 1092.14 275.674C1096.61 275.988 1101.09 276.314 1105.6 276.652C1109.45 276.937 1113.31 277.222 1117.18 277.521C1120.67 277.784 1124.2 278.054 1127.71 278.332C1128.07 278.361 1128.44 278.39 1128.8 278.419C1132.67 278.719 1136.56 279.033 1140.44 279.347C1144.33 279.661 1148.23 279.982 1152.12 280.303C1156.03 280.624 1159.94 280.953 1163.84 281.289C1167.76 281.625 1171.67 281.961 1175.59 282.304C1178.66 282.574 1181.7 282.844 1184.76 283.114C1186.29 283.253 1187.81 283.385 1189.33 283.523C1192.61 283.823 1195.9 284.124 1199.2 284.429C1203.14 284.794 1207.08 285.161 1211.03 285.531C1211.48 285.575 1211.91 285.619 1212.35 285.655C1218.48 286.24 1224.61 286.833 1230.74 287.437C1231.57 287.517 1232.42 287.605 1233.26 287.685C1236.47 287.999 1239.68 288.321 1242.89 288.649C1246.1 288.978 1249.31 289.299 1252.54 289.635C1252.68 289.644 1252.81 289.656 1252.94 289.671C1257.49 290.139 1262.03 290.613 1266.59 291.103C1268.86 291.336 1271.13 291.577 1273.4 291.825C1276.51 292.154 1279.6 292.49 1282.72 292.833C1284.75 293.059 1286.79 293.286 1288.84 293.512C1290.35 293.665 1291.85 293.833 1293.36 294.009C1296.54 294.352 1299.72 294.707 1302.91 295.075C1305.87 295.411 1308.83 295.749 1311.8 296.09C1311.88 296.096 1311.96 296.106 1312.05 296.119C1312.76 296.199 1313.45 296.28 1314.16 296.36C1316.33 296.608 1318.5 296.864 1320.69 297.119C1322.92 297.382 1325.17 297.645 1327.42 297.915C1329.39 298.149 1331.38 298.382 1333.35 298.623C1333.4 298.624 1333.46 298.629 1333.51 298.638C1333.79 298.667 1334.08 298.704 1334.36 298.74C1336.64 299.01 1338.93 299.281 1341.21 299.565C1343.49 299.843 1345.78 300.12 1348.08 300.405C1348.31 300.427 1348.54 300.456 1348.77 300.485C1350.54 300.697 1352.32 300.916 1354.09 301.143C1354.09 301.143 1354.09 301.135 1354.1 301.143C1355.11 301.259 1356.12 301.391 1357.13 301.515C1359.83 301.851 1362.53 302.189 1365.23 302.53C1366.96 302.749 1368.72 302.968 1370.46 303.194C1375.31 303.815 1380.17 304.436 1385.04 305.071C1389.9 305.706 1394.79 306.349 1399.65 306.999C1402.58 307.386 1405.5 307.78 1408.43 308.181C1411.17 308.547 1413.92 308.919 1416.67 309.299C1420.77 309.861 1424.9 310.423 1429 311Z"
          fill="#979786"
          fillOpacity="0.24"
        />
        <g id="Leaves2">
          <path
            id="Stem"
            d="M1063.34 295.205C1063.34 295.205 1069.13 279.146 1062.25 267.327C1059.37 262.367 1058.41 256.798 1059.74 251.414C1060.38 248.858 1061.3 246.356 1062.5 243.937"
            stroke="#535461"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="Vector"
            d="M1058.22 236.481C1058.22 238.45 1062.58 244.15 1062.58 244.15C1062.58 244.15 1066.95 238.443 1066.95 236.481C1066.92 235.551 1066.45 234.665 1065.64 234.015C1064.82 233.364 1063.73 233 1062.59 233C1061.45 233 1060.35 233.364 1059.54 234.015C1058.72 234.665 1058.25 235.551 1058.22 236.481H1058.22Z"
            fill="#9C7945"
          />
          <path
            id="Vector_2"
            d="M1051.01 247.382C1052.32 249.035 1059.78 251.888 1059.78 251.888C1059.78 251.888 1059.64 245.16 1058.33 243.508C1057.69 242.74 1056.71 242.208 1055.59 242.025C1054.47 241.842 1053.31 242.022 1052.36 242.528C1051.4 243.033 1050.73 243.823 1050.48 244.73C1050.22 245.636 1050.41 246.588 1051.01 247.381V247.382Z"
            fill="#9C7945"
          />
          <path
            id="Vector_3"
            d="M1051.32 266.012C1053.48 266.897 1061.68 266.286 1061.68 266.286C1061.68 266.286 1057.4 260.534 1055.25 259.649C1054.22 259.245 1053.04 259.188 1051.96 259.488C1050.88 259.789 1049.98 260.424 1049.47 261.257C1048.95 262.09 1048.86 263.055 1049.21 263.944C1049.55 264.833 1050.31 265.575 1051.32 266.012H1051.32Z"
            fill="#9C7945"
          />
          <path
            id="Vector_4"
            d="M1055.45 280.059C1057.39 281.228 1065.6 281.758 1065.6 281.758C1065.6 281.758 1062.58 275.5 1060.64 274.329C1060.18 274.046 1059.65 273.84 1059.1 273.724C1058.54 273.607 1057.96 273.582 1057.39 273.65C1056.82 273.718 1056.27 273.877 1055.77 274.118C1055.28 274.36 1054.85 274.679 1054.51 275.057C1054.16 275.436 1053.92 275.865 1053.78 276.322C1053.64 276.779 1053.61 277.253 1053.7 277.718C1053.79 278.183 1053.99 278.629 1054.29 279.031C1054.59 279.433 1054.98 279.782 1055.45 280.059Z"
            fill="#9C7945"
          />
          <path
            id="Vector_5"
            d="M1068.95 252.269C1067.22 253.64 1059.17 255.061 1059.17 255.061C1059.17 255.061 1061.14 248.529 1062.87 247.156C1063.28 246.83 1063.77 246.573 1064.3 246.4C1064.83 246.228 1065.4 246.142 1065.97 246.149C1066.55 246.156 1067.11 246.254 1067.64 246.44C1068.16 246.625 1068.64 246.893 1069.04 247.229C1069.44 247.565 1069.75 247.962 1069.97 248.397C1070.18 248.832 1070.28 249.296 1070.27 249.764C1070.27 250.232 1070.14 250.694 1069.92 251.124C1069.69 251.554 1069.36 251.943 1068.95 252.269Z"
            fill="#9C7945"
          />
          <path
            id="Vector_6"
            d="M1073.51 268.748C1071.36 269.633 1063.16 269.022 1063.16 269.022C1063.16 269.022 1067.43 263.27 1069.58 262.384C1070.1 262.16 1070.66 262.021 1071.24 261.977C1071.82 261.933 1072.4 261.984 1072.96 262.127C1073.51 262.27 1074.03 262.503 1074.47 262.811C1074.92 263.119 1075.28 263.497 1075.54 263.921C1075.8 264.346 1075.96 264.809 1076 265.284C1076.04 265.758 1075.96 266.234 1075.77 266.684C1075.58 267.134 1075.28 267.548 1074.9 267.903C1074.51 268.257 1074.04 268.544 1073.51 268.748Z"
            fill="#9C7945"
          />
          <path
            id="Vector_7"
            d="M1075.26 285.27C1073.32 286.439 1065.11 286.969 1065.11 286.969C1065.11 286.969 1068.13 280.711 1070.07 279.539C1071 278.986 1072.16 278.756 1073.3 278.899C1074.44 279.042 1075.46 279.546 1076.14 280.302C1076.83 281.058 1077.12 282.004 1076.95 282.935C1076.79 283.865 1076.18 284.705 1075.26 285.27Z"
            fill="#9C7945"
          />
          <path
            id="Vector_8"
            opacity="0.25"
            d="M1058.22 236.481C1058.22 238.45 1062.58 244.15 1062.58 244.15C1062.58 244.15 1066.95 238.443 1066.95 236.481C1066.92 235.551 1066.45 234.665 1065.64 234.015C1064.82 233.364 1063.73 233 1062.59 233C1061.45 233 1060.35 233.364 1059.54 234.015C1058.72 234.665 1058.25 235.551 1058.22 236.481H1058.22Z"
            fill="black"
          />
          <path
            id="Vector_9"
            opacity="0.25"
            d="M1051.01 247.382C1052.32 249.035 1059.78 251.888 1059.78 251.888C1059.78 251.888 1059.64 245.16 1058.33 243.508C1057.69 242.74 1056.71 242.208 1055.59 242.025C1054.47 241.842 1053.31 242.022 1052.36 242.528C1051.4 243.033 1050.73 243.823 1050.48 244.73C1050.22 245.636 1050.41 246.588 1051.01 247.381V247.382Z"
            fill="black"
          />
          <path
            id="Vector_10"
            opacity="0.25"
            d="M1051.32 266.012C1053.48 266.897 1061.68 266.286 1061.68 266.286C1061.68 266.286 1057.4 260.534 1055.25 259.649C1054.22 259.245 1053.04 259.188 1051.96 259.488C1050.88 259.789 1049.98 260.424 1049.47 261.257C1048.95 262.09 1048.86 263.055 1049.21 263.944C1049.55 264.833 1050.31 265.575 1051.32 266.012H1051.32Z"
            fill="black"
          />
          <path
            id="Vector_11"
            opacity="0.25"
            d="M1055.45 280.059C1057.39 281.228 1065.6 281.758 1065.6 281.758C1065.6 281.758 1062.58 275.5 1060.64 274.329C1060.18 274.046 1059.65 273.84 1059.1 273.724C1058.54 273.607 1057.96 273.582 1057.39 273.65C1056.82 273.718 1056.27 273.877 1055.77 274.118C1055.28 274.36 1054.85 274.679 1054.51 275.057C1054.16 275.436 1053.92 275.865 1053.78 276.322C1053.64 276.779 1053.61 277.253 1053.7 277.718C1053.79 278.183 1053.99 278.629 1054.29 279.031C1054.59 279.433 1054.98 279.782 1055.45 280.059Z"
            fill="black"
          />
          <path
            id="Vector_12"
            opacity="0.25"
            d="M1068.95 252.269C1067.22 253.64 1059.17 255.061 1059.17 255.061C1059.17 255.061 1061.14 248.529 1062.87 247.156C1063.28 246.83 1063.77 246.573 1064.3 246.4C1064.83 246.228 1065.4 246.142 1065.97 246.149C1066.55 246.156 1067.11 246.254 1067.64 246.44C1068.16 246.625 1068.64 246.893 1069.04 247.229C1069.44 247.565 1069.75 247.962 1069.97 248.397C1070.18 248.832 1070.28 249.296 1070.27 249.764C1070.27 250.232 1070.14 250.694 1069.92 251.124C1069.69 251.554 1069.36 251.943 1068.95 252.269Z"
            fill="black"
          />
          <path
            id="Vector_13"
            opacity="0.25"
            d="M1073.51 268.748C1071.36 269.633 1063.16 269.022 1063.16 269.022C1063.16 269.022 1067.43 263.27 1069.58 262.384C1070.1 262.16 1070.66 262.021 1071.24 261.977C1071.82 261.933 1072.4 261.984 1072.96 262.127C1073.51 262.27 1074.03 262.503 1074.47 262.811C1074.92 263.119 1075.28 263.497 1075.54 263.921C1075.8 264.346 1075.96 264.809 1076 265.284C1076.04 265.758 1075.96 266.234 1075.77 266.684C1075.58 267.134 1075.28 267.548 1074.9 267.903C1074.51 268.257 1074.04 268.544 1073.51 268.748Z"
            fill="black"
          />
          <path
            id="Vector_14"
            opacity="0.25"
            d="M1075.26 285.27C1073.32 286.439 1065.11 286.969 1065.11 286.969C1065.11 286.969 1068.13 280.711 1070.07 279.539C1071 278.986 1072.16 278.756 1073.3 278.899C1074.44 279.042 1075.46 279.546 1076.14 280.302C1076.83 281.058 1077.12 282.004 1076.95 282.935C1076.79 283.865 1076.18 284.705 1075.26 285.27Z"
            fill="black"
          />
        </g>
        <g id="Mountain">
          <path
            id="Vector_15"
            d="M806.685 123.408C794.625 117.634 780.334 111.469 757.953 109.584C732.035 107.4 705.41 111.738 682.826 116.018C615.287 128.819 550.246 142.691 488 157.571L488.068 157.795C536.529 156.828 584.99 155.861 633.45 154.893C668.463 154.194 704.679 153.399 735.62 148.604C747.362 146.785 758.807 144.354 772.112 144.185C788.642 143.975 803.055 147.317 814.382 150.808C881.383 171.462 900.772 203.046 975.941 221.191C928.542 187.353 871.946 154.656 806.685 123.408Z"
            fill="#F2F2F2"
            fillOpacity="0.07"
          />
          <path
            id="Vector_16"
            d="M1206.44 247.837C1199.03 245.812 1196.01 245.338 1188.7 243.294C1129.19 226.635 1073.25 209.412 1020.89 191.627C985.327 179.549 951.525 167.238 919.488 154.695C904.235 148.732 889.401 142.722 874.985 136.666C863.798 131.97 852.861 127.245 842.174 122.493C839.117 121.136 836.147 119.772 833.192 118.405C826.229 115.191 819.395 111.962 812.058 108.792C803.697 105.178 793.519 101.39 778.165 98.9626C771.178 97.8124 762.822 97.1165 754.075 96.9562C741.577 96.7814 730.044 97.8985 719.203 99.1186C639.884 108.071 565.627 119.295 498.461 132.066C431.124 144.867 370.936 159.328 319.123 175.155C317.538 175.645 313.789 175.177 315.389 174.684C321.689 172.756 328.114 170.848 334.664 168.961C416.105 145.517 515.965 125.356 629.677 109.4C648.809 106.717 668.299 104.159 688.15 101.727C698.155 100.501 708.203 99.2902 718.424 98.1544C728.444 97.0404 739.083 96.0388 750.529 96.0013C789.482 95.8703 809.65 105.419 823.504 111.843C827.858 113.865 832.265 115.881 836.724 117.891C853.576 125.52 871.078 133.079 889.228 140.569C900.429 145.194 911.876 149.791 923.568 154.361C959.954 168.593 998.628 182.537 1039.59 196.192C1093.85 214.281 1147.68 230.26 1209.5 247.176C1211.2 247.644 1208.16 248.312 1206.44 247.837Z"
            fill="#E4E4E4"
          />
          <path
            id="Vector_17"
            d="M513.055 123.847C510.77 122.989 508.499 122.131 506.199 121.274C488.062 114.522 468.619 107.878 443.873 104.285C432.073 102.51 419.223 101.695 406.214 101.895C392.77 102.171 379.664 103.688 367.291 105.695C361.442 106.648 355.725 107.713 350.097 108.837C343.666 110.126 337.353 111.491 331.069 112.865C319.274 115.444 307.636 118.122 296.154 120.901C273.309 126.431 251.195 132.334 229.811 138.612C218.727 141.868 207.875 145.219 197.257 148.665C187.381 151.866 177.709 155.144 168.24 158.499C166.215 159.214 163.133 158.181 165.157 157.466C167.653 156.578 170.177 155.694 172.702 154.82C179.833 152.352 187.081 149.927 194.446 147.544C207.875 143.191 221.66 138.99 235.8 134.94C257.788 128.638 280.549 122.72 304.085 117.186C315.846 114.422 327.773 111.762 339.866 109.205C343.517 108.433 347.212 107.676 350.951 106.954C359.432 105.251 368.253 103.789 377.328 102.583C390.182 100.841 403.814 100.097 417.292 100.403C430.309 100.828 442.875 102.136 454.329 104.258C478.649 108.627 497.617 115.744 516.076 122.691C517.94 123.397 514.933 124.553 513.055 123.847Z"
            fill="#E4E4E4"
          />
          <path
            id="Vector_18"
            d="M1010.08 186.079L1064.36 177.865L1091.31 173.787C1100.09 172.459 1108.84 170.947 1117.92 169.996C1125.8 169.064 1134.18 169.108 1142 170.123C1148.98 171.191 1155.37 172.83 1160.79 174.94C1166.32 177.049 1171.47 179.324 1176.19 181.747C1182.06 184.665 1187.84 187.613 1193.65 190.551C1217.62 202.677 1241.43 214.856 1265.08 227.087C1288.73 239.319 1312.23 251.602 1335.56 263.937C1358.96 276.302 1382.19 288.719 1405.26 301.188C1408.09 302.716 1410.91 304.244 1413.73 305.773C1415.29 306.618 1418.81 305.785 1417.22 304.928C1393.98 292.334 1370.58 279.791 1347.01 267.3C1323.39 254.78 1299.6 242.312 1275.65 229.897C1251.7 217.483 1227.59 205.122 1203.32 192.815C1197.27 189.749 1191.21 186.687 1185.14 183.627C1180.03 181.047 1174.97 178.438 1169.35 176.037C1159.05 171.628 1146.18 167.731 1130.77 167.626C1121.71 167.564 1112.94 168.753 1104.52 170.013C1095.44 171.371 1086.39 172.755 1077.33 174.126L1022.67 182.397L1009 184.465C1006.58 184.832 1007.62 186.45 1010.08 186.079Z"
            fill="#E4E4E4"
          />
          <path
            id="Vector_19"
            d="M437.227 112.243C407.735 107.855 369.967 108.714 342.867 114.196C394.559 116.778 445.686 120.232 495.985 124.541C475.098 120.998 458.759 115.446 437.227 112.243Z"
            fill="#F2F2F2"
            fillOpacity="0.07"
          />
          <path
            id="Vector_20"
            d="M342.576 114.181L336.899 115.517C338.819 115.049 340.816 114.611 342.867 114.196C342.77 114.191 342.673 114.186 342.576 114.181Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_21"
            d="M1161.32 187.893C1156.56 185.473 1151.42 182.949 1144.47 182.249L1138.04 182.733C1189.36 221.321 1257.57 253.721 1338.47 277.946C1279.42 247.928 1220.37 217.911 1161.32 187.893Z"
            fill="#F2F2F2"
            fillOpacity="0.07"
          />
        </g>
        <g id="TreeSet1">
          <path
            id="Vector_22"
            d="M221.628 191.788H216.928V288.191H221.628V191.788Z"
            fill="#56483D"
          />
          <path
            id="Vector_23"
            d="M264.999 190.619C265.298 227.949 219.543 258.332 219.543 258.332C219.543 258.332 173.301 228.192 173.001 190.862C172.702 153.533 218.457 123.15 218.457 123.15C218.457 123.15 264.699 153.289 264.999 190.619Z"
            fill="#32542D"
          />
          <path
            id="Vector_24"
            d="M163.5 166.272H158.105V296.57H163.5V166.272Z"
            fill="#56483D"
          />
          <path
            id="Vector_25"
            d="M219.998 157.851C220.386 198.157 161.202 230.964 161.202 230.964C161.202 230.964 101.39 198.42 101.002 158.113C100.614 117.807 159.798 85 159.798 85C159.798 85 219.61 117.544 219.998 157.851Z"
            fill="#32542D"
          />
          <path
            id="Vector_26"
            d="M109.451 191.788H104.751V304.637H109.451V191.788Z"
            fill="#56483D"
          />
          <path
            id="Vector_27"
            d="M152.999 190.619C153.298 227.949 107.543 258.332 107.543 258.332C107.543 258.332 61.3012 228.192 61.0015 190.862C60.7017 153.533 106.457 123.15 106.457 123.15C106.457 123.15 152.699 153.289 152.999 190.619Z"
            fill="#32542D"
          />
        </g>
        <g id="TreeSet3">
          <path
            id="Vector_28"
            d="M356.225 181.368H352.486V274.417H356.225V181.368Z"
            fill="#56483D"
          />
          <path
            id="Vector_29"
            d="M387.999 194.897C388.237 226.93 351.931 253.002 351.931 253.002C351.931 253.002 315.239 227.139 315.001 195.106C314.763 163.072 351.069 137 351.069 137C351.069 137 387.761 162.864 387.999 194.897Z"
            fill="#32542D"
          />
        </g>
        <g id="LeafSet6">
          <path
            id="Vector_30"
            d="M43.8432 303.187C46.0411 306.777 53.5694 309 53.5694 309C53.5694 309 57.5343 305.403 55.3364 301.813C53.1384 298.223 45.6101 296 45.6101 296C45.6101 296 41.6453 299.597 43.8432 303.187Z"
            fill="#5B7458"
          />
          <path
            id="Vector_31"
            d="M47.0728 302.416C53.1039 305.01 53.8406 308.997 53.8406 308.997C53.8406 308.997 44.7989 308.779 38.7678 306.185C32.7367 303.591 32 299.603 32 299.603C32 299.603 41.0417 299.822 47.0728 302.416Z"
            fill="#5B7458"
          />
        </g>
        <g id="LeafSet5">
          <path
            id="Vector_32"
            d="M1158.41 282.187C1159.61 285.777 1163.68 288 1163.68 288C1163.68 288 1165.83 284.403 1164.64 280.813C1163.45 277.223 1159.37 275 1159.37 275C1159.37 275 1157.22 278.597 1158.41 282.187Z"
            fill="#5B7458"
          />
          <path
            id="Vector_33"
            d="M1160.16 281.416C1163.43 284.01 1163.83 287.997 1163.83 287.997C1163.83 287.997 1158.93 287.779 1155.67 285.185C1152.4 282.591 1152 278.603 1152 278.603C1152 278.603 1156.9 278.822 1160.16 281.416Z"
            fill="#5B7458"
          />
        </g>
        <g id="LeafSet4">
          <path
            id="Vector_34"
            d="M200.909 286.634C202.191 289.948 206.582 292 206.582 292C206.582 292 208.895 288.68 207.613 285.366C206.331 282.052 201.939 280 201.939 280C201.939 280 199.626 283.32 200.909 286.634Z"
            fill="#5B7458"
          />
          <path
            id="Vector_35"
            d="M202.792 285.922C206.311 288.317 206.74 291.997 206.74 291.997C206.74 291.997 201.466 291.796 197.948 289.402C194.43 287.007 194 283.326 194 283.326C194 283.326 199.274 283.528 202.792 285.922Z"
            fill="#5B7458"
          />
        </g>
        <g id="LeafSet3">
          <path
            id="Vector_36"
            d="M572.909 265.976C574.191 268.461 578.582 270 578.582 270C578.582 270 580.895 267.51 579.613 265.024C578.331 262.539 573.939 261 573.939 261C573.939 261 571.626 263.49 572.909 265.976Z"
            fill="#5B7458"
          />
          <path
            id="Vector_37"
            d="M574.792 265.442C578.311 267.237 578.74 269.998 578.74 269.998C578.74 269.998 573.466 269.847 569.948 268.051C566.43 266.255 566 263.495 566 263.495C566 263.495 571.274 263.646 574.792 265.442Z"
            fill="#5B7458"
          />
        </g>
        <g id="Flower15">
          <path
            id="Vector_38"
            d="M882.549 299.002C882.549 299.002 883.082 290.197 894 291.221L882.549 299.002Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_39"
            d="M879.464 290.623C882.482 290.623 884.929 288.693 884.929 286.311C884.929 283.93 882.482 282 879.464 282C876.447 282 874 283.93 874 286.311C874 288.693 876.447 290.623 879.464 290.623Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_40"
            d="M880.118 293.571H878.575V302.09H880.118V293.571Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower14">
          <path
            id="Vector_41"
            d="M1303.55 301.002C1303.55 301.002 1304.08 292.197 1315 293.221L1303.55 301.002Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_42"
            d="M1300.46 292.623C1303.48 292.623 1305.93 290.693 1305.93 288.311C1305.93 285.93 1303.48 284 1300.46 284C1297.45 284 1295 285.93 1295 288.311C1295 290.693 1297.45 292.623 1300.46 292.623Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_43"
            d="M1301.12 295.571H1299.58V304.09H1301.12V295.571Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower13">
          <path
            id="Vector_44"
            d="M525.549 285.002C525.549 285.002 526.082 276.197 537 277.221L525.549 285.002Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_45"
            d="M522.464 276.623C525.482 276.623 527.929 274.693 527.929 272.311C527.929 269.93 525.482 268 522.464 268C519.447 268 517 269.93 517 272.311C517 274.693 519.447 276.623 522.464 276.623Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_46"
            d="M523.118 279.571H521.575V288.09H523.118V279.571Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower12">
          <path
            id="Vector_47"
            d="M1231.42 294.078C1231.42 294.078 1231.63 288.341 1236 289.008L1231.42 294.078Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_48"
            d="M1230.19 288.618C1231.39 288.618 1232.37 287.361 1232.37 285.809C1232.37 284.258 1231.39 283 1230.19 283C1228.98 283 1228 284.258 1228 285.809C1228 287.361 1228.98 288.618 1230.19 288.618Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_49"
            d="M1230.45 290.539H1229.83V296.09H1230.45V290.539Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower11">
          <path
            id="Vector_50"
            d="M409.275 280.232C409.275 280.232 409.541 274.933 415 275.549L409.275 280.232Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_51"
            d="M407.732 275.189C409.241 275.189 410.464 274.028 410.464 272.595C410.464 271.162 409.241 270 407.732 270C406.223 270 405 271.162 405 272.595C405 274.028 406.223 275.189 407.732 275.189Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_52"
            d="M408.059 276.963H407.288V282.09H408.059V276.963Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower10">
          <path
            id="Vector_53"
            d="M497.275 269.693C497.275 269.693 497.541 265.709 503 266.172L497.275 269.693Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_54"
            d="M495.732 265.902C497.241 265.902 498.464 265.028 498.464 263.951C498.464 262.873 497.241 262 495.732 262C494.223 262 493 262.873 493 263.951C493 265.028 494.223 265.902 495.732 265.902Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_55"
            d="M496.059 267.235H495.288V271.09H496.059V267.235Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower9">
          <path
            id="Vector_56"
            d="M655.977 304.156C655.977 304.156 656.536 295.789 668 296.762L655.977 304.156Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_57"
            d="M652.738 296.194C655.906 296.194 658.475 294.359 658.475 292.097C658.475 289.834 655.906 288 652.738 288C649.569 288 647 289.834 647 292.097C647 294.359 649.569 296.194 652.738 296.194Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_58"
            d="M653.424 298.995H651.804V307.09H653.424V298.995Z"
            fill="#3F3D56"
          />
        </g>
        <motion.path
          animate={{ y: [0, 180, 140, 100], x: [0, -300, -600, -900] }}
          transition={{ duration: 7 }}
          id="Bird2"
          d="M1053.95 44.8923L1074 34.1504C1058.43 32.9993 1052.03 38.6896 1049.41 43.1934C1037.24 39.8087 1024 44.2445 1024 44.2445L1064.11 54C1062.08 50.3791 1058.56 47.2197 1053.95 44.8923Z"
          fill="#3F3D56"
        />
        <motion.path
          animate={{ y: [0, 160, 120, 100], x: [0, -300, -600, -900] }}
          transition={{ duration: 7 }}
          id="Bird3"
          d="M1120.95 82.8923L1141 72.1504C1125.43 70.9993 1119.03 76.6896 1116.41 81.1934C1104.24 77.8087 1091 82.2445 1091 82.2445L1131.11 92C1129.08 88.3791 1125.56 85.2197 1120.95 82.8923Z"
          fill="#3F3D56"
        />
        <motion.path
          animate={{ y: [0, 180, 160, 100], x: [0, -300, -400, -600] }}
          transition={{ duration: 7 }}
          id="Bird1"
          d="M969.776 73.2546L988.829 60.8369C973.215 61.0225 967.327 67.2394 965.104 71.9508C952.693 69.6195 939.877 75.1723 939.877 75.1723L980.672 81.4601C978.346 78.0256 974.567 75.1792 969.776 73.2546Z"
          fill="#3F3D56"
        />
        <g id="Leaves1">
          <path
            id="Stem_2"
            d="M330.451 299.555C330.451 299.555 336.62 285.215 329.294 274.659C326.218 270.23 325.198 265.256 326.618 260.448C327.297 258.166 328.281 255.931 329.556 253.771"
            stroke="#535461"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_59"
            d="M325 247.109C325 248.867 329.649 253.958 329.649 253.958C329.649 253.958 334.297 248.861 334.297 247.109C334.269 246.278 333.767 245.487 332.898 244.906C332.03 244.325 330.864 244 329.65 244C328.436 244 327.27 244.325 326.401 244.906C325.533 245.487 325.031 246.278 325.003 247.109H325Z"
            fill="#9C7945"
          />
          <path
            id="Vector_60"
            d="M317.317 256.844C318.712 258.32 326.658 260.868 326.658 260.868C326.658 260.868 326.513 254.86 325.118 253.384C324.794 253.022 324.367 252.708 323.864 252.46C323.36 252.213 322.788 252.037 322.184 251.942C321.579 251.848 320.952 251.838 320.342 251.912C319.731 251.987 319.148 252.144 318.628 252.374C318.107 252.605 317.659 252.905 317.31 253.256C316.961 253.608 316.719 254.003 316.597 254.419C316.474 254.836 316.475 255.265 316.599 255.681C316.722 256.097 316.967 256.492 317.317 256.843V256.844Z"
            fill="#9C7945"
          />
          <path
            id="Vector_61"
            d="M317.662 273.481C319.954 274.272 328.691 273.726 328.691 273.726C328.691 273.726 324.138 268.59 321.845 267.799C321.298 267.598 320.698 267.474 320.081 267.435C319.463 267.395 318.84 267.441 318.249 267.569C317.657 267.697 317.109 267.904 316.636 268.179C316.164 268.455 315.777 268.792 315.498 269.171C315.218 269.55 315.053 269.964 315.011 270.388C314.969 270.812 315.051 271.237 315.253 271.639C315.454 272.04 315.771 272.41 316.185 272.727C316.599 273.043 317.101 273.3 317.662 273.481Z"
            fill="#9C7945"
          />
          <path
            id="Vector_62"
            d="M322.047 286.029C324.11 287.074 332.859 287.546 332.859 287.546C332.859 287.546 329.639 281.958 327.576 280.912C326.584 280.418 325.347 280.212 324.135 280.34C322.923 280.467 321.834 280.918 321.104 281.593C320.375 282.268 320.065 283.113 320.242 283.944C320.418 284.775 321.067 285.525 322.047 286.029Z"
            fill="#9C7945"
          />
          <path
            id="Vector_63"
            d="M336.415 261.209C334.574 262.433 325.995 263.701 325.995 263.701C325.995 263.701 328.096 257.868 329.936 256.642C330.82 256.054 332.01 255.73 333.243 255.743C334.475 255.755 335.651 256.102 336.51 256.707C337.369 257.313 337.841 258.127 337.824 258.971C337.806 259.816 337.299 260.62 336.415 261.209Z"
            fill="#9C7945"
          />
          <path
            id="Vector_64"
            d="M341.283 275.93C338.99 276.721 330.254 276.174 330.254 276.174C330.254 276.174 334.807 271.038 337.1 270.247C338.197 269.887 339.457 269.835 340.608 270.104C341.76 270.372 342.712 270.94 343.26 271.683C343.808 272.427 343.908 273.289 343.539 274.083C343.17 274.877 342.361 275.54 341.285 275.93H341.283Z"
            fill="#9C7945"
          />
          <path
            id="Vector_65"
            d="M343.146 290.68C341.083 291.724 332.334 292.197 332.334 292.197C332.334 292.197 335.555 286.608 337.617 285.562C338.609 285.068 339.846 284.863 341.058 284.99C342.27 285.118 343.359 285.568 344.089 286.243C344.818 286.918 345.128 287.764 344.952 288.595C344.775 289.426 344.126 290.175 343.146 290.68Z"
            fill="#9C7945"
          />
          <path
            id="Vector_66"
            opacity="0.25"
            d="M325 247.109C325 248.867 329.649 253.958 329.649 253.958C329.649 253.958 334.297 248.861 334.297 247.109C334.269 246.278 333.767 245.487 332.898 244.906C332.03 244.325 330.864 244 329.65 244C328.436 244 327.27 244.325 326.401 244.906C325.533 245.487 325.031 246.278 325.003 247.109H325Z"
            fill="black"
          />
          <path
            id="Vector_67"
            opacity="0.25"
            d="M317.317 256.844C318.712 258.32 326.658 260.868 326.658 260.868C326.658 260.868 326.513 254.86 325.118 253.384C324.794 253.022 324.367 252.708 323.864 252.46C323.36 252.213 322.788 252.037 322.184 251.942C321.579 251.848 320.952 251.838 320.342 251.912C319.731 251.987 319.148 252.144 318.628 252.374C318.107 252.605 317.659 252.905 317.31 253.256C316.961 253.608 316.719 254.003 316.597 254.419C316.474 254.836 316.475 255.265 316.599 255.681C316.722 256.097 316.967 256.492 317.317 256.843V256.844Z"
            fill="black"
          />
          <path
            id="Vector_68"
            opacity="0.25"
            d="M317.662 273.481C319.954 274.272 328.691 273.726 328.691 273.726C328.691 273.726 324.138 268.59 321.845 267.799C321.298 267.598 320.698 267.474 320.081 267.435C319.463 267.395 318.84 267.441 318.249 267.569C317.657 267.697 317.109 267.904 316.636 268.179C316.164 268.455 315.777 268.792 315.498 269.171C315.218 269.55 315.053 269.964 315.011 270.388C314.969 270.812 315.051 271.237 315.253 271.639C315.454 272.04 315.771 272.41 316.185 272.727C316.599 273.043 317.101 273.3 317.662 273.481Z"
            fill="black"
          />
          <path
            id="Vector_69"
            opacity="0.25"
            d="M322.047 286.029C324.11 287.074 332.859 287.546 332.859 287.546C332.859 287.546 329.639 281.958 327.576 280.912C326.584 280.418 325.347 280.212 324.135 280.34C322.923 280.467 321.834 280.918 321.104 281.593C320.375 282.268 320.065 283.113 320.242 283.944C320.418 284.775 321.067 285.525 322.047 286.029Z"
            fill="black"
          />
          <path
            id="Vector_70"
            opacity="0.25"
            d="M336.415 261.209C334.574 262.433 325.995 263.701 325.995 263.701C325.995 263.701 328.096 257.868 329.936 256.642C330.82 256.054 332.01 255.73 333.243 255.743C334.475 255.755 335.651 256.102 336.51 256.707C337.369 257.313 337.841 258.127 337.824 258.971C337.806 259.816 337.299 260.62 336.415 261.209Z"
            fill="black"
          />
          <path
            id="Vector_71"
            opacity="0.25"
            d="M341.283 275.93C338.99 276.721 330.254 276.174 330.254 276.174C330.254 276.174 334.807 271.038 337.1 270.247C338.197 269.887 339.457 269.835 340.608 270.104C341.76 270.372 342.712 270.94 343.26 271.683C343.808 272.427 343.908 273.289 343.539 274.083C343.17 274.877 342.361 275.54 341.285 275.93H341.283Z"
            fill="black"
          />
          <path
            id="Vector_72"
            opacity="0.25"
            d="M343.146 290.68C341.083 291.724 332.334 292.197 332.334 292.197C332.334 292.197 335.555 286.608 337.617 285.562C338.609 285.068 339.846 284.863 341.058 284.99C342.27 285.118 343.359 285.568 344.089 286.243C344.818 286.918 345.128 287.764 344.952 288.595C344.775 289.426 344.126 290.175 343.146 290.68Z"
            fill="black"
          />
        </g>
        <path
          id="Vector_73"
          d="M681.997 310.422C680.264 309.522 678.635 308.461 678.13 307.171C677.624 305.881 678.613 304.331 680.829 303.854C683.305 303.323 685.96 304.268 687.968 305.251C689.976 306.234 692.281 307.325 694.907 307.117C693.555 306.433 692.543 305.566 691.971 304.599C691.399 303.633 691.286 302.6 691.642 301.602C691.757 301.19 692.071 300.803 692.549 300.482C693.925 299.653 696.424 300.014 698.067 300.661C703.273 302.734 704.76 306.686 704.797 310.26C705.325 308.971 704.879 307.627 704.894 306.304C704.909 304.982 705.556 303.518 707.556 302.804C708.814 302.429 710.228 302.247 711.654 302.278C714.011 302.228 716.636 302.361 718.242 303.323C720.243 304.517 719.73 306.52 717.982 307.835C716.235 309.149 713.595 309.974 711.163 310.882C709.211 311.531 707.546 312.417 706.292 313.474C706.143 313.622 706.021 313.778 705.928 313.939H691.129C687.814 313.002 684.742 311.819 681.997 310.422Z"
          fill="#9C7945"
        />
        <path
          id="Vector_74"
          d="M1186.5 299.468C1185.42 298.564 1184.4 297.498 1184.08 296.203C1183.76 294.907 1184.38 293.35 1185.77 292.871C1187.32 292.337 1188.98 293.287 1190.24 294.274C1191.5 295.261 1192.94 296.357 1194.58 296.148C1193.74 295.462 1193.1 294.59 1192.75 293.62C1192.39 292.649 1192.32 291.612 1192.54 290.609C1192.61 290.195 1192.81 289.806 1193.11 289.484C1193.97 288.651 1195.53 289.014 1196.56 289.663C1199.82 291.746 1200.75 295.715 1200.78 299.306C1201.11 298.01 1200.83 296.661 1200.84 295.332C1200.85 294.003 1201.25 292.533 1202.5 291.817C1203.29 291.44 1204.18 291.257 1205.07 291.288C1206.54 291.238 1208.19 291.371 1209.19 292.337C1210.44 293.537 1210.12 295.549 1209.03 296.869C1207.94 298.189 1206.28 299.018 1204.76 299.93C1203.54 300.582 1202.5 301.472 1201.71 302.534C1201.62 302.682 1201.54 302.838 1201.48 303H1192.22C1190.14 302.059 1188.22 300.871 1186.5 299.468Z"
          fill="#9C7945"
        />
        <path
          id="Vector_75"
          d="M847.732 266.982C846.981 266.465 846.275 265.856 846.056 265.116C845.837 264.376 846.266 263.485 847.226 263.212C848.299 262.907 849.45 263.45 850.32 264.014C851.19 264.578 852.189 265.204 853.327 265.085C852.741 264.692 852.303 264.195 852.055 263.64C851.807 263.085 851.758 262.492 851.912 261.919C851.962 261.683 852.098 261.461 852.306 261.277C852.902 260.801 853.985 261.008 854.697 261.379C856.953 262.569 857.598 264.837 857.614 266.889C857.843 266.149 857.649 265.378 857.656 264.618C857.662 263.859 857.942 263.019 858.809 262.61C859.354 262.394 859.967 262.29 860.585 262.307C861.607 262.279 862.745 262.355 863.441 262.907C864.308 263.593 864.085 264.742 863.328 265.497C862.571 266.251 861.427 266.725 860.373 267.246C859.527 267.618 858.805 268.127 858.262 268.733C858.197 268.818 858.144 268.908 858.104 269H851.69C850.253 268.462 848.922 267.783 847.732 266.982Z"
          fill="#9C7945"
        />
        <path
          id="Vector_76"
          d="M408.791 297.72C407.581 296.881 406.444 295.891 406.091 294.688C405.737 293.485 406.428 292.039 407.975 291.594C409.705 291.099 411.558 291.981 412.96 292.897C414.362 293.814 415.972 294.831 417.805 294.638C416.861 294 416.155 293.191 415.755 292.29C415.356 291.388 415.277 290.425 415.525 289.494C415.606 289.11 415.825 288.749 416.159 288.45C417.12 287.676 418.864 288.013 420.012 288.616C423.647 290.55 424.685 294.236 424.711 297.569C425.08 296.367 424.768 295.114 424.779 293.88C424.789 292.646 425.241 291.281 426.637 290.616C427.516 290.265 428.503 290.096 429.499 290.124C431.145 290.078 432.978 290.202 434.099 291.099C435.496 292.213 435.138 294.081 433.917 295.307C432.697 296.533 430.854 297.303 429.156 298.15C427.793 298.755 426.63 299.581 425.755 300.567C425.651 300.705 425.566 300.85 425.5 301H415.167C412.853 300.126 410.708 299.023 408.791 297.72Z"
          fill="#9C7945"
        />
        <g id="Grass21">
          <path
            id="Vector_77"
            d="M140 306.284C140 306.284 140.277 295.889 145.946 297.098L140 306.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_78"
            d="M139.946 305.284C139.946 305.284 139.669 294.889 134 296.098L139.946 305.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Leaves2_2">
          <path
            id="Vector_79"
            d="M1427.82 263.738C1427.82 263.738 1465.1 281.783 1389.41 301.906C1389.41 301.906 1376.01 281.263 1395.77 266.199C1399.61 263.262 1404.93 261.363 1410.74 260.861C1416.54 260.36 1422.42 261.291 1427.26 263.478L1427.82 263.738Z"
            fill="#9C7945"
          />
          <path
            id="Vector_80"
            d="M1427.41 263.378C1427.41 263.378 1391.51 278.565 1389.41 301.903"
            stroke="#535461"
            strokeMiterlimit="10"
          />
          <path
            id="Stem_3"
            d="M1388.64 299.205C1388.64 299.205 1401.02 271.271 1386.32 250.712C1380.15 242.084 1378.1 232.396 1380.95 223.032C1382.32 218.586 1384.29 214.232 1386.85 210.025"
            stroke="#535461"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_81"
            d="M1377.7 197.056C1377.7 200.481 1387.03 210.396 1387.03 210.396C1387.03 210.396 1396.35 200.467 1396.35 197.056C1396.3 195.437 1395.29 193.897 1393.55 192.765C1391.8 191.634 1389.47 191 1387.03 191C1384.59 191 1382.26 191.634 1380.51 192.765C1378.77 193.897 1377.76 195.437 1377.71 197.056H1377.7Z"
            fill="#9C7945"
          />
          <path
            id="Vector_82"
            d="M1362.29 216.018C1365.09 218.893 1381.03 223.855 1381.03 223.855C1381.03 223.855 1380.74 212.153 1377.94 209.278C1376.57 207.943 1374.47 207.018 1372.08 206.699C1369.7 206.381 1367.22 206.694 1365.18 207.573C1363.14 208.452 1361.69 209.827 1361.15 211.404C1360.61 212.981 1361.02 214.636 1362.29 216.015V216.018Z"
            fill="#9C7945"
          />
          <path
            id="Vector_83"
            d="M1362.97 248.424C1367.57 249.964 1385.09 248.901 1385.09 248.901C1385.09 248.901 1375.96 238.896 1371.36 237.355C1369.16 236.653 1366.63 236.553 1364.32 237.076C1362.01 237.599 1360.1 238.704 1359 240.153C1357.9 241.602 1357.7 243.28 1358.44 244.826C1359.18 246.373 1360.8 247.664 1362.96 248.424H1362.97Z"
            fill="#9C7945"
          />
          <path
            id="Vector_84"
            d="M1371.78 272.859C1375.92 274.893 1393.47 275.814 1393.47 275.814C1393.47 275.814 1387.01 264.928 1382.87 262.891C1381.89 262.399 1380.77 262.041 1379.57 261.839C1378.38 261.636 1377.14 261.592 1375.92 261.71C1374.7 261.828 1373.53 262.105 1372.48 262.525C1371.42 262.945 1370.5 263.5 1369.77 264.158C1369.04 264.816 1368.51 265.564 1368.21 266.358C1367.92 267.153 1367.86 267.978 1368.05 268.787C1368.23 269.596 1368.66 270.372 1369.3 271.071C1369.94 271.77 1370.78 272.377 1371.78 272.859Z"
            fill="#9C7945"
          />
          <path
            id="Vector_85"
            d="M1400.63 224.519C1396.94 226.903 1379.73 229.375 1379.73 229.375C1379.73 229.375 1383.94 218.012 1387.63 215.625C1388.51 215.057 1389.55 214.611 1390.69 214.31C1391.83 214.009 1393.04 213.86 1394.27 213.872C1395.49 213.884 1396.7 214.056 1397.83 214.378C1398.95 214.701 1399.97 215.167 1400.82 215.751C1401.67 216.335 1402.35 217.025 1402.8 217.782C1403.25 218.539 1403.47 219.347 1403.46 220.161C1403.44 220.976 1403.18 221.779 1402.7 222.527C1402.21 223.275 1401.51 223.952 1400.63 224.519Z"
            fill="#9C7945"
          />
          <path
            id="Vector_86"
            d="M1410.37 253.183C1405.77 254.724 1388.25 253.66 1388.25 253.66C1388.25 253.66 1397.38 243.655 1401.98 242.114C1403.08 241.723 1404.28 241.482 1405.52 241.405C1406.76 241.328 1408.01 241.417 1409.19 241.666C1410.38 241.915 1411.48 242.32 1412.43 242.856C1413.38 243.392 1414.15 244.049 1414.71 244.787C1415.27 245.526 1415.61 246.332 1415.69 247.157C1415.77 247.983 1415.61 248.811 1415.2 249.594C1414.8 250.376 1414.16 251.097 1413.33 251.713C1412.5 252.329 1411.5 252.829 1410.37 253.183Z"
            fill="#9C7945"
          />
          <path
            id="Vector_87"
            d="M1414.11 281.923C1409.97 283.957 1392.42 284.878 1392.42 284.878C1392.42 284.878 1398.88 273.993 1403.02 271.955C1405.01 270.993 1407.49 270.592 1409.92 270.841C1412.35 271.089 1414.54 271.967 1416 273.282C1417.46 274.597 1418.09 276.243 1417.73 277.861C1417.38 279.48 1416.07 280.94 1414.11 281.923Z"
            fill="#9C7945"
          />
          <path
            id="Vector_88"
            opacity="0.25"
            d="M1377.7 197.056C1377.7 200.481 1387.03 210.396 1387.03 210.396C1387.03 210.396 1396.35 200.467 1396.35 197.056C1396.3 195.437 1395.29 193.897 1393.55 192.765C1391.8 191.634 1389.47 191 1387.03 191C1384.59 191 1382.26 191.634 1380.51 192.765C1378.77 193.897 1377.76 195.437 1377.71 197.056H1377.7Z"
            fill="black"
          />
          <path
            id="Vector_89"
            opacity="0.25"
            d="M1362.29 216.018C1365.09 218.893 1381.03 223.855 1381.03 223.855C1381.03 223.855 1380.74 212.153 1377.94 209.278C1376.57 207.943 1374.47 207.018 1372.08 206.699C1369.7 206.381 1367.22 206.694 1365.18 207.573C1363.14 208.452 1361.69 209.827 1361.15 211.404C1360.61 212.981 1361.02 214.636 1362.29 216.015V216.018Z"
            fill="black"
          />
          <path
            id="Vector_90"
            opacity="0.25"
            d="M1362.97 248.424C1367.57 249.964 1385.09 248.901 1385.09 248.901C1385.09 248.901 1375.96 238.896 1371.36 237.355C1369.16 236.653 1366.63 236.553 1364.32 237.076C1362.01 237.599 1360.1 238.704 1359 240.153C1357.9 241.602 1357.7 243.28 1358.44 244.826C1359.18 246.373 1360.8 247.664 1362.96 248.424H1362.97Z"
            fill="black"
          />
          <path
            id="Vector_91"
            opacity="0.25"
            d="M1371.78 272.859C1375.92 274.893 1393.47 275.814 1393.47 275.814C1393.47 275.814 1387.01 264.928 1382.87 262.891C1381.89 262.399 1380.77 262.041 1379.57 261.839C1378.38 261.636 1377.14 261.592 1375.92 261.71C1374.7 261.828 1373.53 262.105 1372.48 262.525C1371.42 262.945 1370.5 263.5 1369.77 264.158C1369.04 264.816 1368.51 265.564 1368.21 266.358C1367.92 267.153 1367.86 267.978 1368.05 268.787C1368.23 269.596 1368.66 270.372 1369.3 271.071C1369.94 271.77 1370.78 272.377 1371.78 272.859Z"
            fill="black"
          />
          <path
            id="Vector_92"
            opacity="0.25"
            d="M1400.63 224.519C1396.94 226.903 1379.73 229.375 1379.73 229.375C1379.73 229.375 1383.94 218.012 1387.63 215.625C1388.51 215.057 1389.55 214.611 1390.69 214.31C1391.83 214.009 1393.04 213.86 1394.27 213.872C1395.49 213.884 1396.7 214.056 1397.83 214.378C1398.95 214.701 1399.97 215.167 1400.82 215.751C1401.67 216.335 1402.35 217.025 1402.8 217.782C1403.25 218.539 1403.47 219.347 1403.46 220.161C1403.44 220.976 1403.18 221.779 1402.7 222.527C1402.21 223.275 1401.51 223.952 1400.63 224.519Z"
            fill="black"
          />
          <path
            id="Vector_93"
            opacity="0.25"
            d="M1410.37 253.183C1405.77 254.724 1388.25 253.66 1388.25 253.66C1388.25 253.66 1397.38 243.655 1401.98 242.114C1403.08 241.723 1404.28 241.482 1405.52 241.405C1406.76 241.328 1408.01 241.417 1409.19 241.666C1410.38 241.915 1411.48 242.32 1412.43 242.856C1413.38 243.392 1414.15 244.049 1414.71 244.787C1415.27 245.526 1415.61 246.332 1415.69 247.157C1415.77 247.983 1415.61 248.811 1415.2 249.594C1414.8 250.376 1414.16 251.097 1413.33 251.713C1412.5 252.329 1411.5 252.829 1410.37 253.183Z"
            fill="black"
          />
          <path
            id="Vector_94"
            opacity="0.25"
            d="M1414.11 281.923C1409.97 283.957 1392.42 284.878 1392.42 284.878C1392.42 284.878 1398.88 273.993 1403.02 271.955C1405.01 270.993 1407.49 270.592 1409.92 270.841C1412.35 271.089 1414.54 271.967 1416 273.282C1417.46 274.597 1418.09 276.243 1417.73 277.861C1417.38 279.48 1416.07 280.94 1414.11 281.923Z"
            fill="black"
          />
        </g>
        <g id="Flower8">
          <path
            id="Vector_95"
            d="M622.565 272.068C622.565 272.068 622.725 268.408 626 268.833L622.565 272.068Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_96"
            d="M621.639 268.585C622.545 268.585 623.279 267.782 623.279 266.792C623.279 265.802 622.545 265 621.639 265C620.734 265 620 265.802 620 266.792C620 267.782 620.734 268.585 621.639 268.585Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_97"
            d="M621.835 269.458H621.373V273H621.835V269.458Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower7">
          <path
            id="Vector_98"
            d="M662.847 274.835C662.847 274.835 663.087 270.26 668 270.791L662.847 274.835Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_99"
            d="M661.459 270.481C662.817 270.481 663.918 269.478 663.918 268.24C663.918 267.003 662.817 266 661.459 266C660.101 266 659 267.003 659 268.24C659 269.478 660.101 270.481 661.459 270.481Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_100"
            d="M661.753 271.573H661.059V276H661.753V271.573Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass18">
          <path
            id="Vector_101"
            d="M441 285.284C441 285.284 441.277 274.889 446.946 276.098L441 285.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_102"
            d="M440.946 286.284C440.946 286.284 440.669 275.889 435 277.098L440.946 286.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass17">
          <path
            id="Vector_103"
            d="M368 290.284C368 290.284 368.277 279.889 373.946 281.098L368 290.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_104"
            d="M367.946 291.284C367.946 291.284 367.669 280.889 362 282.098L367.946 291.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Group 20">
          <path
            id="Vector_105"
            d="M814 312.284C814 312.284 814.277 301.889 819.946 303.098L814 312.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_106"
            d="M813.946 311.284C813.946 311.284 813.669 300.889 808 302.098L813.946 311.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Group 19">
          <path
            id="Vector_107"
            d="M625.843 299.282C625.843 299.282 626.119 288.887 631.788 290.095L625.843 299.282Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_108"
            d="M625.946 297.284C625.946 297.284 625.669 286.889 620 288.098L625.946 297.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass16">
          <path
            id="Vector_109"
            d="M481 297.284C481 297.284 481.277 286.889 486.946 288.098L481 297.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_110"
            d="M480.946 296.284C480.946 296.284 480.669 285.889 475 287.098L480.946 296.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass15">
          <path
            id="Vector_111"
            d="M922 293.284C922 293.284 922.277 282.889 927.946 284.098L922 293.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_112"
            d="M921.946 292.284C921.946 292.284 921.669 281.889 916 283.098L921.946 292.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass14">
          <path
            id="Vector_113"
            d="M1141 303.284C1141 303.284 1141.28 292.889 1146.95 294.098L1141 303.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_114"
            d="M1140.95 302.284C1140.95 302.284 1140.67 291.889 1135 293.098L1140.95 302.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass13">
          <path
            id="Vector_115"
            d="M1256.55 311C1256.55 311 1257.03 290.785 1267 293.135L1256.55 311Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_116"
            d="M1256.45 309.055C1256.45 309.055 1255.97 288.84 1246 291.19L1256.45 309.055Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass12">
          <path
            id="Vector_117"
            d="M903 272C903 272 903.277 263.914 908.946 264.854L903 272Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_118"
            d="M902.946 271.222C902.946 271.222 902.669 263.136 897 264.076L902.946 271.222Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass11">
          <path
            id="Vector_119"
            d="M1103 279C1103 279 1103.28 270.914 1108.95 271.854L1103 279Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_120"
            d="M1102.95 278.222C1102.95 278.222 1102.67 270.136 1097 271.076L1102.95 278.222Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass10">
          <path
            id="Vector_121"
            d="M1331 302C1331 302 1331.28 293.914 1336.95 294.854L1331 302Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_122"
            d="M1330.95 301.222C1330.95 301.222 1330.67 293.136 1325 294.076L1330.95 301.222Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass9">
          <path
            id="Vector_123"
            d="M1009.05 295.284C1009.05 295.284 1009.51 277.814 1019 279.845L1009.05 295.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_124"
            d="M1008.95 293.604C1008.95 293.604 1008.49 276.134 999 278.164L1008.95 293.604Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass8">
          <path
            id="Vector_125"
            d="M593 288.284C593 288.284 593.277 277.889 598.946 279.098L593 288.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_126"
            d="M592.946 287.284C592.946 287.284 592.669 276.889 587 278.098L592.946 287.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="LeafSet2">
          <path
            id="Vector_127"
            d="M953.35 306.952C955.456 312.423 962.671 315.811 962.671 315.811C962.671 315.811 966.47 310.33 964.364 304.859C962.258 299.388 955.043 296 955.043 296C955.043 296 951.243 301.482 953.35 306.952Z"
            fill="#5B7458"
          />
          <path
            id="Vector_128"
            d="M956.445 305.777C962.224 309.73 962.93 315.807 962.93 315.807C962.93 315.807 954.266 315.475 948.486 311.521C942.706 307.568 942 301.491 942 301.491C942 301.491 950.665 301.824 956.445 305.777Z"
            fill="#5B7458"
          />
        </g>
        <g id="LeafSet1">
          <path
            id="Vector_129"
            d="M776.948 263.211C777.68 264.316 780.19 265 780.19 265C780.19 265 781.511 263.893 780.779 262.789C780.046 261.684 777.537 261 777.537 261C777.537 261 776.215 262.107 776.948 263.211Z"
            fill="#5B7458"
          />
          <path
            id="Vector_130"
            d="M778.024 262.974C780.035 263.772 780.28 264.999 780.28 264.999C780.28 264.999 777.266 264.932 775.256 264.134C773.246 263.336 773 262.109 773 262.109C773 262.109 776.014 262.176 778.024 262.974Z"
            fill="#5B7458"
          />
        </g>
        <g id="Flower6">
          <path
            id="Vector_131"
            d="M1099.55 304.757C1099.55 304.757 1100.08 297.114 1111 298.003L1099.55 304.757Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_132"
            d="M1096.46 297.484C1099.48 297.484 1101.93 295.809 1101.93 293.742C1101.93 291.675 1099.48 290 1096.46 290C1093.45 290 1091 291.675 1091 293.742C1091 295.809 1093.45 297.484 1096.46 297.484Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_133"
            d="M1097.12 300.042H1095.58V307.436H1097.12V300.042Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower5">
          <path
            id="Vector_134"
            d="M729.839 292.804C729.839 292.804 730.266 285.137 739 286.029L729.839 292.804Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_135"
            d="M727.372 285.508C729.786 285.508 731.743 283.828 731.743 281.754C731.743 279.681 729.786 278 727.372 278C724.957 278 723 279.681 723 281.754C723 283.828 724.957 285.508 727.372 285.508Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_136"
            d="M727.894 288.075H726.66V295.493H727.894V288.075Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower4">
          <path
            id="Vector_137"
            d="M955.847 283.002C955.847 283.002 956.087 277.304 961 277.966L955.847 283.002Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_138"
            d="M954.459 277.58C955.817 277.58 956.918 276.331 956.918 274.79C956.918 273.249 955.817 272 954.459 272C953.101 272 952 273.249 952 274.79C952 276.331 953.101 277.58 954.459 277.58Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_139"
            d="M954.753 279.487H954.059V285H954.753V279.487Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower3">
          <path
            id="Vector_140"
            d="M814.275 272.677C814.275 272.677 814.541 269.219 820 269.621L814.275 272.677Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_141"
            d="M812.732 269.386C814.241 269.386 815.464 268.628 815.464 267.693C815.464 266.758 814.241 266 812.732 266C811.223 266 810 266.758 810 267.693C810 268.628 811.223 269.386 812.732 269.386Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_142"
            d="M813.059 270.544H812.288V273.889H813.059V270.544Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower2">
          <path
            id="Vector_143"
            d="M985.565 276.135C985.565 276.135 985.725 272.958 989 273.327L985.565 276.135Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_144"
            d="M984.639 273.111C985.545 273.111 986.279 272.415 986.279 271.556C986.279 270.696 985.545 270 984.639 270C983.734 270 983 270.696 983 271.556C983 272.415 983.734 273.111 984.639 273.111Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_145"
            d="M984.835 273.87H984.373V276.943H984.835V273.87Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Flower1">
          <path
            id="Vector_146"
            d="M1036.85 283.668C1036.85 283.668 1037.09 279.697 1042 280.159L1036.85 283.668Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_147"
            d="M1035.46 279.889C1036.82 279.889 1037.92 279.019 1037.92 277.945C1037.92 276.871 1036.82 276 1035.46 276C1034.1 276 1033 276.871 1033 277.945C1033 279.019 1034.1 279.889 1035.46 279.889Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_148"
            d="M1035.75 280.837H1035.06V284.679H1035.75V280.837Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass7">
          <path
            id="Vector_149"
            d="M767 285.058C767 285.058 767.277 276.036 772.946 277.085L767 285.058Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_150"
            d="M766.946 285.926C766.946 285.926 766.669 276.904 761 277.953L766.946 285.926Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass6">
          <path
            id="Vector_151"
            d="M714 263.611C714 263.611 714.277 259.568 719.946 260.038L714 263.611Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_152"
            d="M713.946 264C713.946 264 713.669 259.957 708 260.427L713.946 264Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass5">
          <path
            id="Vector_153"
            d="M368 290.416C368 290.416 368.277 281.394 373.946 282.443L368 290.416Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_154"
            d="M367.946 291.284C367.946 291.284 367.669 282.262 362 283.311L367.946 291.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass4">
          <path
            id="Vector_155"
            d="M840 290.926C840 290.926 840.277 281.904 845.946 282.953L840 290.926Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_156"
            d="M839.946 290.058C839.946 290.058 839.669 281.036 834 282.085L839.946 290.058Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass3">
          <path
            id="Vector_157"
            d="M554 302.284C554 302.284 554.277 291.889 559.946 293.098L554 302.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_158"
            d="M553.946 301.284C553.946 301.284 553.669 290.889 548 292.098L553.946 301.284Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass2">
          <path
            id="Vector_159"
            d="M234.018 292C234.018 292 234.203 282.903 238 283.961L234.018 292Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_160"
            d="M233.982 291.125C233.982 291.125 233.797 282.028 230 283.086L233.982 291.125Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Grass1">
          <path
            id="Vector_161"
            d="M194.557 314.284C194.557 314.284 195.136 296.814 207 298.845L194.557 314.284Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_162"
            d="M194.443 312.604C194.443 312.604 193.864 295.134 182 297.164L194.443 312.604Z"
            fill="#3F3D56"
          />
        </g>
        <g id="Leaves">
          <path
            id="Stem_4"
            d="M673.557 270.264C673.557 270.264 678.2 256.79 672.688 246.875C670.346 242.729 669.64 238.044 670.676 233.526C671.188 231.384 671.927 229.286 672.886 227.26"
            stroke="#535461"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_163"
            d="M669.456 220.99C669.456 222.642 672.952 227.429 672.952 227.429C672.952 227.429 676.449 222.639 676.449 220.99C676.449 220.197 676.08 219.437 675.424 218.876C674.768 218.315 673.878 218 672.951 218C672.023 218 671.133 218.315 670.477 218.876C669.821 219.437 669.453 220.197 669.453 220.99H669.456Z"
            fill="#9C7945"
          />
          <path
            id="Vector_164"
            d="M663.674 230.136C664.716 231.52 670.704 233.915 670.704 233.915C670.704 233.915 670.596 228.27 669.547 226.885C669.297 226.555 668.974 226.271 668.596 226.048C668.218 225.825 667.792 225.668 667.343 225.586C666.893 225.504 666.43 225.498 665.978 225.569C665.526 225.64 665.095 225.786 664.709 226C664.324 226.213 663.991 226.489 663.73 226.813C663.469 227.136 663.286 227.5 663.19 227.884C663.093 228.268 663.087 228.665 663.17 229.051C663.253 229.437 663.424 229.806 663.674 230.136Z"
            fill="#9C7945"
          />
          <path
            id="Vector_165"
            d="M663.927 245.767C665.665 246.509 672.226 245.995 672.226 245.995C672.226 245.995 668.8 241.17 667.076 240.428C666.665 240.251 666.218 240.145 665.759 240.116C665.301 240.087 664.84 240.136 664.403 240.259C663.967 240.382 663.563 240.578 663.214 240.835C662.866 241.092 662.581 241.404 662.374 241.756C662.167 242.107 662.043 242.489 662.009 242.881C661.976 243.273 662.033 243.667 662.177 244.041C662.321 244.414 662.55 244.759 662.85 245.057C663.151 245.355 663.517 245.599 663.927 245.776V245.767Z"
            fill="#9C7945"
          />
          <path
            id="Vector_166"
            d="M667.232 257.556C668.786 258.537 675.368 258.982 675.368 258.982C675.368 258.982 672.935 253.732 671.392 252.743C671.023 252.509 670.603 252.339 670.157 252.244C669.712 252.148 669.248 252.129 668.793 252.186C668.339 252.244 667.902 252.378 667.507 252.58C667.113 252.782 666.769 253.048 666.495 253.364C666.222 253.68 666.023 254.038 665.912 254.419C665.8 254.801 665.777 255.197 665.845 255.586C665.912 255.974 666.068 256.348 666.305 256.685C666.541 257.022 666.853 257.316 667.222 257.55L667.232 257.556Z"
            fill="#9C7945"
          />
          <path
            id="Vector_167"
            d="M678.047 234.236C676.657 235.386 670.207 236.577 670.207 236.577C670.207 236.577 671.788 231.095 673.171 229.945C673.498 229.66 673.888 229.433 674.319 229.278C674.749 229.124 675.212 229.044 675.679 229.045C676.146 229.046 676.608 229.126 677.038 229.282C677.468 229.438 677.857 229.667 678.183 229.953C678.508 230.24 678.762 230.58 678.931 230.952C679.101 231.324 679.181 231.722 679.167 232.121C679.153 232.52 679.046 232.913 678.852 233.276C678.658 233.639 678.381 233.966 678.037 234.236H678.047Z"
            fill="#9C7945"
          />
          <path
            id="Vector_168"
            d="M681.707 248.066C679.969 248.809 673.408 248.295 673.408 248.295C673.408 248.295 676.834 243.47 678.558 242.727C678.969 242.551 679.416 242.445 679.875 242.416C680.333 242.387 680.794 242.436 681.231 242.559C681.667 242.682 682.071 242.878 682.419 243.135C682.768 243.391 683.053 243.704 683.26 244.055C683.467 244.407 683.591 244.789 683.624 245.181C683.658 245.573 683.601 245.967 683.457 246.34C683.313 246.714 683.084 247.059 682.784 247.357C682.483 247.654 682.117 247.899 681.707 248.075V248.066Z"
            fill="#9C7945"
          />
          <path
            id="Vector_169"
            d="M683.111 261.924C681.557 262.904 674.975 263.35 674.975 263.35C674.975 263.35 677.408 258.1 678.951 257.111C679.696 256.638 680.631 256.438 681.549 256.554C682.468 256.67 683.294 257.094 683.847 257.732C684.4 258.369 684.635 259.168 684.498 259.953C684.362 260.738 683.867 261.445 683.121 261.918L683.111 261.924Z"
            fill="#9C7945"
          />
          <path
            id="Vector_170"
            opacity="0.5"
            d="M669.456 220.99C669.456 222.642 672.952 227.429 672.952 227.429C672.952 227.429 676.449 222.639 676.449 220.99C676.449 220.197 676.08 219.437 675.424 218.876C674.768 218.315 673.878 218 672.951 218C672.023 218 671.133 218.315 670.477 218.876C669.821 219.437 669.453 220.197 669.453 220.99H669.456Z"
            fill="white"
          />
          <path
            id="Vector_171"
            opacity="0.5"
            d="M663.674 230.136C664.716 231.52 670.704 233.915 670.704 233.915C670.704 233.915 670.596 228.27 669.547 226.885C669.297 226.555 668.974 226.271 668.596 226.048C668.218 225.825 667.792 225.668 667.343 225.586C666.893 225.504 666.43 225.498 665.978 225.569C665.526 225.64 665.095 225.786 664.709 226C664.324 226.213 663.991 226.489 663.73 226.813C663.469 227.136 663.286 227.5 663.19 227.884C663.093 228.268 663.087 228.665 663.17 229.051C663.253 229.437 663.424 229.806 663.674 230.136Z"
            fill="white"
          />
          <path
            id="Vector_172"
            opacity="0.5"
            d="M663.927 245.767C665.665 246.509 672.226 245.995 672.226 245.995C672.226 245.995 668.8 241.17 667.076 240.428C666.665 240.251 666.218 240.145 665.759 240.116C665.301 240.087 664.84 240.136 664.403 240.259C663.967 240.382 663.563 240.578 663.214 240.835C662.866 241.092 662.581 241.404 662.374 241.756C662.167 242.107 662.043 242.489 662.009 242.881C661.976 243.273 662.033 243.667 662.177 244.041C662.321 244.414 662.55 244.759 662.85 245.057C663.151 245.355 663.517 245.599 663.927 245.776V245.767Z"
            fill="white"
          />
          <path
            id="Vector_173"
            opacity="0.5"
            d="M667.232 257.556C668.786 258.537 675.368 258.982 675.368 258.982C675.368 258.982 672.935 253.732 671.392 252.743C671.023 252.509 670.603 252.339 670.157 252.244C669.712 252.148 669.248 252.129 668.793 252.186C668.339 252.244 667.902 252.378 667.507 252.58C667.113 252.782 666.769 253.048 666.495 253.364C666.222 253.68 666.023 254.038 665.912 254.419C665.8 254.801 665.777 255.197 665.845 255.586C665.912 255.974 666.068 256.348 666.305 256.685C666.541 257.022 666.853 257.316 667.222 257.55L667.232 257.556Z"
            fill="white"
          />
          <path
            id="Vector_174"
            opacity="0.5"
            d="M678.047 234.236C676.657 235.386 670.207 236.577 670.207 236.577C670.207 236.577 671.788 231.095 673.171 229.945C673.498 229.66 673.888 229.433 674.319 229.278C674.749 229.124 675.212 229.044 675.679 229.045C676.146 229.046 676.608 229.126 677.038 229.282C677.468 229.438 677.857 229.667 678.183 229.953C678.508 230.24 678.762 230.58 678.931 230.952C679.101 231.324 679.181 231.722 679.167 232.121C679.153 232.52 679.046 232.913 678.852 233.276C678.658 233.639 678.381 233.966 678.037 234.236H678.047Z"
            fill="white"
          />
          <path
            id="Vector_175"
            opacity="0.5"
            d="M681.707 248.066C679.969 248.809 673.408 248.295 673.408 248.295C673.408 248.295 676.834 243.47 678.558 242.727C678.969 242.551 679.416 242.445 679.875 242.416C680.333 242.387 680.794 242.436 681.231 242.559C681.667 242.682 682.071 242.878 682.419 243.135C682.768 243.391 683.053 243.704 683.26 244.055C683.467 244.407 683.591 244.789 683.624 245.181C683.658 245.573 683.601 245.967 683.457 246.34C683.313 246.714 683.084 247.059 682.784 247.357C682.483 247.654 682.117 247.899 681.707 248.075V248.066Z"
            fill="white"
          />
          <path
            id="Vector_176"
            opacity="0.5"
            d="M683.111 261.924C681.557 262.904 674.975 263.35 674.975 263.35C674.975 263.35 677.408 258.1 678.951 257.111C679.696 256.638 680.631 256.438 681.549 256.554C682.468 256.67 683.294 257.094 683.847 257.732C684.4 258.369 684.635 259.168 684.498 259.953C684.362 260.738 683.867 261.445 683.121 261.918L683.111 261.924Z"
            fill="white"
          />
        </g>
        <g id="Stars">
          <motion.path
            initial={{ scale: 0.5 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 3 }}
            id="center1"
            d="M589.28 66C592.749 66 595.561 65.3284 595.561 64.5C595.561 63.6716 592.749 63 589.28 63C585.812 63 583 63.6716 583 64.5C583 65.3284 585.812 66 589.28 66Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 0.5 }}
            id="right8"
            d="M1047.94 172C1050.02 172 1051.71 171.24 1051.71 170.302C1051.71 169.365 1050.02 168.605 1047.94 168.605C1045.86 168.605 1044.17 169.365 1044.17 170.302C1044.17 171.24 1045.86 172 1047.94 172Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="Vector_177"
            d="M207.671 67H205V67.6132H207.671V67Z"
            fill="#F2F2F2"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right7"
            d="M1073.77 116.395C1075.85 116.395 1077.54 115.635 1077.54 114.697C1077.54 113.76 1075.85 113 1073.77 113C1071.69 113 1070 113.76 1070 114.697C1070 115.635 1071.69 116.395 1073.77 116.395Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right7_2"
            d="M990.768 129.5C992.849 129.5 994.536 129.388 994.536 129.25C994.536 129.112 992.849 129 990.768 129C988.687 129 987 129.112 987 129.25C987 129.388 988.687 129.5 990.768 129.5Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right7_3"
            d="M1185.77 131.5C1187.85 131.5 1189.54 131.388 1189.54 131.25C1189.54 131.112 1187.85 131 1185.77 131C1183.69 131 1182 131.112 1182 131.25C1182 131.388 1183.69 131.5 1185.77 131.5Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="center2"
            d="M802.961 43.4417C805.042 43.4417 806.729 42.9939 806.729 42.4417C806.729 41.8894 805.042 41.4417 802.961 41.4417C800.88 41.4417 799.193 41.8894 799.193 42.4417C799.193 42.9939 800.88 43.4417 802.961 43.4417Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left5"
            d="M363.768 85.395C365.849 85.395 367.536 84.635 367.536 83.6975C367.536 82.76 365.849 82 363.768 82C361.687 82 360 82.76 360 83.6975C360 84.635 361.687 85.395 363.768 85.395Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left4"
            d="M236.981 130.578C239.063 130.578 240.75 129.818 240.75 128.88C240.75 127.943 239.063 127.183 236.981 127.183C234.9 127.183 233.213 127.943 233.213 128.88C233.213 129.818 234.9 130.578 236.981 130.578Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left3"
            d="M133.741 39.5835C135.822 39.5835 137.509 39.3596 137.509 39.0835C137.509 38.8074 135.822 38.5835 133.741 38.5835C131.66 38.5835 129.973 38.8074 129.973 39.0835C129.973 39.3596 131.66 39.5835 133.741 39.5835Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left5_2"
            d="M261.87 52.0157C263.951 52.0157 265.638 51.568 265.638 51.0157C265.638 50.4635 263.951 50.0157 261.87 50.0157C259.789 50.0157 258.102 50.4635 258.102 51.0157C258.102 51.568 259.789 52.0157 261.87 52.0157Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left1"
            d="M3.76824 27.6883C5.84938 27.6883 7.53648 26.9283 7.53648 25.9908C7.53648 25.0533 5.84938 24.2933 3.76824 24.2933C1.6871 24.2933 0 25.0533 0 25.9908C0 26.9283 1.6871 27.6883 3.76824 27.6883Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0.5 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="left2"
            d="M24.7682 89C26.8494 89 28.5365 88.5523 28.5365 88C28.5365 87.4477 26.8494 87 24.7682 87C22.6871 87 21 87.4477 21 88C21 88.5523 22.6871 89 24.7682 89Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0.5 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right2"
            d="M1396.59 28.1514C1398.68 28.1514 1400.36 27.9275 1400.36 27.6514C1400.36 27.3752 1398.68 27.1514 1396.59 27.1514C1394.51 27.1514 1392.83 27.3752 1392.83 27.6514C1392.83 27.9275 1394.51 28.1514 1396.59 28.1514Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0.2 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right3"
            d="M1380.92 107.714C1383.01 107.714 1384.69 106.954 1384.69 106.016C1384.69 105.079 1383.01 104.319 1380.92 104.319C1378.84 104.319 1377.16 105.079 1377.16 106.016C1377.16 106.954 1378.84 107.714 1380.92 107.714Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0.9 }}
            animate={{ scale: 0.3 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right3_2"
            d="M1320.77 203C1322.85 203 1324.54 202.776 1324.54 202.5C1324.54 202.224 1322.85 202 1320.77 202C1318.69 202 1317 202.224 1317 202.5C1317 202.776 1318.69 203 1320.77 203Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right1"
            d="M1436.23 167.732C1438.31 167.732 1440 166.972 1440 166.035C1440 165.097 1438.31 164.337 1436.23 164.337C1434.15 164.337 1432.46 165.097 1432.46 166.035C1432.46 166.972 1434.15 167.732 1436.23 167.732Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0.4 }}
            animate={{ scale: 1.2 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right5"
            d="M1302.57 129.183C1304.65 129.183 1306.34 128.735 1306.34 128.183C1306.34 127.63 1304.65 127.183 1302.57 127.183C1300.49 127.183 1298.8 127.63 1298.8 128.183C1298.8 128.735 1300.49 129.183 1302.57 129.183Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0.2 }}
            animate={{ scale: 0.9 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right5_2"
            d="M749.768 67C751.849 67 753.536 66.5523 753.536 66C753.536 65.4477 751.849 65 749.768 65C747.687 65 746 65.4477 746 66C746 66.5523 747.687 67 749.768 67Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right5_3"
            d="M1266.77 169C1268.85 169 1270.54 168.552 1270.54 168C1270.54 167.448 1268.85 167 1266.77 167C1264.69 167 1263 167.448 1263 168C1263 168.552 1264.69 169 1266.77 169Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right5_4"
            d="M409.768 43C411.849 43 413.536 42.5523 413.536 42C413.536 41.4477 411.849 41 409.768 41C407.687 41 406 41.4477 406 42C406 42.5523 407.687 43 409.768 43Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 0.8 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right9"
            d="M932.012 24.4354C934.093 24.4354 935.78 23.7639 935.78 22.9354C935.78 22.107 934.093 21.4354 932.012 21.4354C929.931 21.4354 928.244 22.107 928.244 22.9354C928.244 23.7639 929.931 24.4354 932.012 24.4354Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right9_2"
            d="M521.768 23C523.849 23 525.536 22.3284 525.536 21.5C525.536 20.6716 523.849 20 521.768 20C519.687 20 518 20.6716 518 21.5C518 22.3284 519.687 23 521.768 23Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right9_3"
            d="M16.7682 228C18.8494 228 20.5365 227.328 20.5365 226.5C20.5365 225.672 18.8494 225 16.7682 225C14.6871 225 13 225.672 13 226.5C13 227.328 14.6871 228 16.7682 228Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="centerup"
            d="M708.017 1C710.098 1 711.785 0.776142 711.785 0.5C711.785 0.223858 710.098 0 708.017 0C705.936 0 704.249 0.223858 704.249 0.5C704.249 0.776142 705.936 1 708.017 1Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="middle"
            d="M874.602 110.793C876.683 110.793 878.37 110.121 878.37 109.293C878.37 108.464 876.683 107.793 874.602 107.793C872.521 107.793 870.834 108.464 870.834 109.293C870.834 110.121 872.521 110.793 874.602 110.793Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right6"
            d="M1230.67 52.4448C1232.75 52.4448 1234.44 52.221 1234.44 51.9448C1234.44 51.6687 1232.75 51.4448 1230.67 51.4448C1228.59 51.4448 1226.9 51.6687 1226.9 51.9448C1226.9 52.221 1228.59 52.4448 1230.67 52.4448Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right6_2"
            d="M670.768 83C672.849 83 674.536 82.7761 674.536 82.5C674.536 82.2239 672.849 82 670.768 82C668.687 82 667 82.2239 667 82.5C667 82.7761 668.687 83 670.768 83Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right6_3"
            d="M1266.77 26C1268.85 26 1270.54 25.3284 1270.54 24.5C1270.54 23.6716 1268.85 23 1266.77 23C1264.69 23 1263 23.6716 1263 24.5C1263 25.3284 1264.69 26 1266.77 26Z"
            fill="white"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right4"
            d="M1347.01 68.496C1346.44 67.8283 1345.81 67.1663 1345.15 66.5212C1346.21 66.708 1347.26 66.9117 1348.31 67.1323L1347.01 68.496Z"
            fill="#9C7945"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right4_2"
            d="M109.859 110.975C109.281 110.307 108.653 109.645 108 109C109.055 109.187 110.11 109.39 111.153 109.611L109.859 110.975Z"
            fill="#9C7945"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right4_3"
            d="M488.859 60.9747C488.281 60.3071 487.653 59.645 487 59C488.055 59.1867 489.11 59.3904 490.153 59.6111L488.859 60.9747Z"
            fill="#9C7945"
          />
          <motion.path
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 1 }}
            id="right4_4"
            d="M313.859 25.9747C313.281 25.3071 312.653 24.645 312 24C313.055 24.1867 314.11 24.3904 315.153 24.6111L313.859 25.9747Z"
            fill="#9C7945"
          />
          <motion.path
            initial={{ scale: 1 }}
            animate={{ scale: 0.6 }}
            transition={{ repeat: Infinity, duration: 2 }}
            id="right4_5"
            d="M326.859 67.9747C326.281 67.3071 325.653 66.645 325 66C326.055 66.1867 327.11 66.3904 328.153 66.6111L326.859 67.9747Z"
            fill="#9C7945"
          />
          <motion.path
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ repeat: Infinity, duration: 2 }}
            id="left3_2"
            d="M32.7682 157C34.8494 157 36.5365 156.776 36.5365 156.5C36.5365 156.224 34.8494 156 32.7682 156C30.6871 156 29 156.224 29 156.5C29 156.776 30.6871 157 32.7682 157Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4_111">
          <rect width="1440" height="312" fill="white" />
        </clipPath>
      </defs>
    </motion.svg>
  );
};

export default SVGMainBackground;
